export default __webpack_public_path__ + "static/media/Marzena Malec.0d302bee.webp";